export default __webpack_public_path__ + "static/Vulcain_LP2_Thumbnail-2c2d94936133c82fb7a90124dff2a72a.png";